const url = require('url-join')
const isRelativeUrl = require('is-relative-url')

const cheerio = require('cheerio');
const UrlHandler = require('./url-handler')
const BTConstant = require('../utils/bt-constant')
const BRAINTREE_PREFIX = BTConstant.BT_PREFIX
function findImageAndAddPrefix(htmlString, isHTMLDoc=false){
    const $ = cheerio.load(htmlString);
    let found = false; //Don't change the node value using cheerio if img tag is not found
    $('img').each(function() {
        let src = $(this).attr('src');
        if(isRelativeUrl(src) && !src.startsWith(BRAINTREE_PREFIX)){
            found = true;
            $(this).attr('src', url(BTConstant.ASSET_URL, BRAINTREE_PREFIX, src));
        }
    });

    if(found){
        return isHTMLDoc ? $.html() : $(`body`).html()
    }
    return htmlString
}

function findLinksAndAddPrefix(htmlString, isHTMLDoc=false){
    const $ = cheerio.load(htmlString);
    let found = false; //Don't change the node value using cheerio if anchor tag is not found
    $('a').each(function() {
        let href = $(this).attr('href');
        if(href && isRelativeUrl(href)){
            const newHref = UrlHandler.getPrefix(href)         
            if(newHref) {
                found = true;
                $(this).attr('href', newHref);
            }
        }
    });

    if(found){
        return isHTMLDoc ? $.html() : $(`body`).html()
    }
    return htmlString
}

module.exports = {
    findImageAndAddPrefix,
    findLinksAndAddPrefix
}